import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1f8cfb3e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "infiniteScroll"
};
var _hoisted_2 = {
  class: "scroll",
  "infinite-scroll-immediate": false,
  "infinite-scroll-distance": 100,
  "infinite-scroll-delay": 700
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode("无限滚动插槽");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _directive_infinite_scroll = _resolveDirective("infinite-scroll");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_renderSlot(_ctx.$slots, "Iscroll", {}, function () {
    return [_hoisted_3];
  }, true)])), [[_directive_infinite_scroll, _ctx.load]])]);
}